import EditorTopChallenge from './EditorTopChallenge';

export default EditorTopChallenge;
